import {ModuleRouteManifest} from '../types'

export const qualityRouteManifest: ModuleRouteManifest = {
  code: 'quality',
  privateRoutes: [
    'quality-pdca',
    'my-report/*',
    'my-reportitem/*',
    'report/*',
    'reportitem/*',
    'reportitemorganization/*',
    'evidencefile/*',
    'evidence-maturity-management',
    'evidence-maturity-type/*',
    'evidence-maturity-level/*',
    'reportitemorganizationevidence/*',
    'semesterreport/*',
  ],
}
